<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-data-analysis`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M42 4a2 2 0 012 2v28a2 2 0 01-2 2H26v4h5a1 1 0 011 1v2a1 1 0 01-1 1H17a1 1 0 01-1-1v-2a1 1 0 011-1h5v-4H6a2 2 0 01-2-2V6a2 2 0 012-2h36zm-2 4H8v24h32V8zm-5.661 7.708l-1.415-1.415a1 1 0 00-1.415 0l-5.117 5.117-4.52-4.542-.094-.084a.999.999 0 00-1.32.082l-7.165 7.145a1 1 0 000 1.415l1.413 1.413a1 1 0 001.414 0l5.017-5.017 4.555 4.56h.001a1 1 0 001.415-.002l7.232-7.259a1 1 0 00-.001-1.413z"/></svg>
</template>
<script>

export default {
  name: 'IconDataAnalysis',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
